var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2806 14.703L12.5306 21.453C12.4609 21.5227 12.3782 21.578 12.2871 21.6158C12.1961 21.6535 12.0985 21.673 11.9999 21.673C11.9014 21.673 11.8038 21.6535 11.7127 21.6158C11.6217 21.578 11.539 21.5227 11.4693 21.453L4.7193 14.703C4.57857 14.5623 4.49951 14.3714 4.49951 14.1724C4.49951 13.9733 4.57857 13.7825 4.7193 13.6417C4.86003 13.501 5.05091 13.4219 5.24993 13.4219C5.44895 13.4219 5.63982 13.501 5.78055 13.6417L11.2499 19.1121V4.42236C11.2499 4.22345 11.3289 4.03269 11.4696 3.89203C11.6103 3.75138 11.801 3.67236 11.9999 3.67236C12.1988 3.67236 12.3896 3.75138 12.5303 3.89203C12.6709 4.03269 12.7499 4.22345 12.7499 4.42236V19.1121L18.2193 13.6417C18.36 13.501 18.5509 13.4219 18.7499 13.4219C18.949 13.4219 19.1398 13.501 19.2806 13.6417C19.4213 13.7825 19.5003 13.9733 19.5003 14.1724C19.5003 14.3714 19.4213 14.5623 19.2806 14.703Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7e85b5b03793ce82744db0ddb28fc873.svg";
export { ForwardRef as ReactComponent };